/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Toc_TitleInputs */

const en_project_toc_title = /** @type {(inputs: Project_Toc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inside the project`)
};

const lv_project_toc_title = /** @type {(inputs: Project_Toc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par šo darbu`)
};

/**
* | output |
* | --- |
* | "Inside the project" |
*
* @param {Project_Toc_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_toc_title = /** @type {((inputs?: Project_Toc_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Toc_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_toc_title(inputs)
	return en_project_toc_title(inputs)
});